export default [
  {
    width: 7,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 7,
    header: {
      type: 'text',
      caption: 'Exchanger',
    },
    cell: {
      type: 'slot',
      name: 'exchanger',
    },
  },
  {
    width: 5,
    header: {
      type: 'text',
      caption: 'Crypto',
    },
    cell: {
      type: 'slot',
      name: 'crypto',
    },
  },
  {
    width: 5,
    header: {
      type: 'text',
      caption: 'Fiat',
    },
    cell: {
      type: 'slot',
      name: 'fiat',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Rate',
    },
    cell: {
      type: 'slot',
      name: 'rate',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Min enter amount',
    },
    cell: {
      type: 'slot',
      name: 'minEnterAmount',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Max enter amount',
    },
    cell: {
      type: 'slot',
      name: 'maxEnterAmount',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Absolute renter fee',
    },
    cell: {
      type: 'slot',
      name: 'absoluteRenterFee',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Base renter fee',
    },
    cell: {
      type: 'slot',
      name: 'baseRenterFee',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
